import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { AuthenticationGuard } from '../core/services/auth/authentication.guard';
import { PermissionGuard } from '../core/services/permission/permission.guard';
import { ExternalLoginComponent } from './external/external-login/external-login.component';
import { ExternalHomeComponent } from './external/external-home/external-home.component';
import { ExternalValidationComponent } from './external/external-validation/external-validation.component';
import { ExternalAuthenticationGuard } from '../core/services/auth/external-authentication.guard';
import { CommonModule } from '@angular/common';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'home', component: HomeComponent, canActivate: [AuthenticationGuard, PermissionGuard], data: { permission: ['user', 'admin', 'test'] } },
  { path: 'external-login', component: ExternalLoginComponent },
  { path: 'external-validation', component: ExternalValidationComponent, canActivate: [ ExternalAuthenticationGuard ] },
  { path: 'external-home', component: ExternalHomeComponent, canActivate: [ ExternalAuthenticationGuard ] },
  { path: 'not_found', component: NotFoundComponent },
  { path: '**', redirectTo: 'not_found', pathMatch: 'full' }
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
